import type { SVGProps } from 'react'

import type { FileRoutesByFullPath } from '@/routeTree.gen'
import MaterialSymbolsCalendarMonthOutlineRounded from '~icons/material-symbols/calendar-month-outline-rounded'
import MaterialSymbolsCalendarMonthRounded from '~icons/material-symbols/calendar-month-rounded'
import MaterialSymbolsHomeOutlineRounded from '~icons/material-symbols/home-outline-rounded'
import MaterialSymbolsHomeRounded from '~icons/material-symbols/home-rounded'
import MaterialSymbolsTableBarOutlineRounded from '~icons/material-symbols/table-bar-outline-rounded'
import MaterialSymbolsTableBarRounded from '~icons/material-symbols/table-bar-rounded'
import MdiDice5 from '~icons/mdi/dice-5'
import MdiDice5Outline from '~icons/mdi/dice-5-outline'

export type NavItem = {
  to: keyof FileRoutesByFullPath
  label: string
  icon: (props: SVGProps<SVGSVGElement>) => React.ReactNode
  iconActive?: (props: SVGProps<SVGSVGElement>) => React.ReactNode
  module?: string
  superAdminOnly?: boolean
}

export const UserNavItems: NavItem[] = [
  {
    to: '/e/$eventId/',
    label: 'หน้าแรก',
    icon: MaterialSymbolsHomeOutlineRounded,
    iconActive: MaterialSymbolsHomeRounded,
  },
  {
    to: '/e/$eventId/agenda',
    label: 'กำหนดการ',
    icon: MaterialSymbolsCalendarMonthOutlineRounded,
    iconActive: MaterialSymbolsCalendarMonthRounded,
  },
  {
    to: '/e/$eventId/map',
    label: 'ผังโต๊ะ',
    icon: MaterialSymbolsTableBarOutlineRounded,
    iconActive: MaterialSymbolsTableBarRounded,
  },
  {
    to: '/e/$eventId/activities/',
    label: 'กิจกรรม',
    icon: MdiDice5Outline,
    iconActive: MdiDice5,
  },
]
